export default __webpack_public_path__ + "images/PX.bbb34e9.png";